import React from "react";
import { Container, Row, Col } from "reactstrap";
import Permissions from "./Permissions";
import { useParams } from "react-router-dom";

function RolePermissions(props) {
  let { rid } = useParams();
  return (
    <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Roles and Permissions</h3>
        <h3 className="page-subhead subhead">
          You can change and modify user privileges in this section.
        </h3>
      </Col>
    </Row>
    <Permissions rid={rid}></Permissions>
  </Container>
      
  );
}

export default RolePermissions;
